import { Container } from 'react-bootstrap'
import FooterNew from '../components/Footer'
import './termsandservices.scss'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const Agb = () => {
  const { t } = useTranslation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const agb = [
    
    {
      title: t('terms_and_condition_page.details.items.header_1'),
      paragraph: t('terms_and_condition_page.details.items.description_1'),
    },
    {
      title: t('terms_and_condition_page.details.items.header_2'),
      paragraph: t('terms_and_condition_page.details.items.description_2'),
    },
    {
      title: t('terms_and_condition_page.details.items.header_3'),
      paragraph: t('terms_and_condition_page.details.items.description_3'),
    },
    {
      title: t('terms_and_condition_page.details.items.header_4'),
      paragraph: t('terms_and_condition_page.details.items.description_4'),
    },
    {
      title: t('terms_and_condition_page.details.items.header_5'),
      paragraph: t('terms_and_condition_page.details.items.description_5'),
    },
    {
      title: t('terms_and_condition_page.details.items.header_6'),
      paragraph: t('terms_and_condition_page.details.items.description_6'),
    },
    {
      title: t('terms_and_condition_page.details.items.header_7'),
      paragraph: t('terms_and_condition_page.details.items.description_7'),
    },
  ]

  return (
    <>
      <Container className='tns-margin-bottom text-center'>
        <div className='text-center mt-5'>
          <h1 className='pricing-header-1'>{t('terms_and_condition_page.title')}</h1>
        </div>
        {agb.map((section, index) => (
          <div key={index} className='mt-5'>
            <h2 className='mb-3'>{section.title}</h2>
            <p>{section.paragraph}</p>
          </div>
        ))}
      </Container>
      <FooterNew />
    </>
  )
}

export default Agb
